module.exports = "/React/dist/ef93f9d3db5cfa26151f2dbadd78c88d.png";